export const previewCardHeight = 96;
export const previewCardImageHeight = 90;
export const previewCardImageWidth = '120px'; // Needs to be string?
export const eventCardImageHeight = 166;
